import { FormattedMessage } from 'react-intl'

export const AlertSuccessDokumentDetachMessage = (
  <FormattedMessage id="alerts.successMessage.detachDokument" defaultMessage="Sikeres dokumentum leválasztás" />
)

export const AlertSuccessDokumentDeleteMessage = (
  <FormattedMessage id="alerts.successMessage.dokumentDelete" defaultMessage="Sikeres dokumentum törlés" />
)

//* define messages for BackgroundAction to notify user about background job's status
export const AlertDownloadWillStartSoonMessage = (
  <FormattedMessage
    id="backgroundAction.notification.downloadWillStartSoon"
    defaultMessage="Az adatok előkészítése folyamatban van, a letöltés hamarosan elindul."
  />
)

export const AlertEmailWillBeSentMessage = (
  <FormattedMessage
    id="backgroundAction.notification.emailWillBeSent"
    defaultMessage="Az adatok előkészítése folyamatban van, több időt vesz igénybe. A letöltési linket hamarosan elküldjük e-mailben."
  />
)
